import { render, staticRenderFns } from "./DistributorCreate.vue?vue&type=template&id=76a1d812"
import script from "./DistributorCreate.vue?vue&type=script&lang=js"
export * from "./DistributorCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports